/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import axios from "axios";
import { getToken } from "../../../auth";
//BASE_URL
const API_URL = process.env.REACT_APP_API_URL;
const ADDON_URL = `${API_URL}`;

const listAddonData = async (ChefId: any, filterData: any) => {
  const response = await axios.post(`${API_URL}list-addons/${ChefId}`, filterData, getToken());

  return response.data;
};

const updateAddon = async (id: any, updatedData: any) => {
  const res = await axios.put(`${ADDON_URL}/update-addons/${id}`, updatedData, getToken());
  return res.data;
};

const deleteAddon = async (id: any) => {
  const response = await axios.put(`${ADDON_URL}delete-addons/${id}`, getToken());
  return response.data;
};
const enableStatus = async (id: any, enableDisableStatus: any) => {

  const response = await axios
    .put(`${API_URL}enable-disable-addons/${id}`, enableDisableStatus, getToken());
  return response.data;
};

const CreateAddons = async (data: any) => {
  const res = await axios.post(`${ADDON_URL}/add-addons`, data, getToken());
  return res.data;
};

const viewAddonById = async (id: any) => {
  const response = await axios.get(`${ADDON_URL}/view-addons/${id}`, getToken());
  return response.data;
};

const checkDuplicateAddon = async (name: any, chefId: any) => {
    const response = await axios
    .post(`${ADDON_URL}/find-duplicate-addons`, { name, chefId }, getToken());
  return response.data;
};
const getType = async () => {
  const res = await axios.get(`${API_URL}get-type`, getToken());
  return res;
};
export {
  listAddonData, getType,
  CreateAddons,
  updateAddon,
  deleteAddon,
  viewAddonById,
  enableStatus,
  checkDuplicateAddon,
};
